import { render, staticRenderFns } from "./basePlanDetail.vue?vue&type=template&id=d98fb784&scoped=true&"
import script from "./basePlanDetail.vue?vue&type=script&lang=ts&"
export * from "./basePlanDetail.vue?vue&type=script&lang=ts&"
import style0 from "./basePlanDetail.vue?vue&type=style&index=0&id=d98fb784&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d98fb784",
  null
  
)

export default component.exports